import { LineItem } from 'codegen';

export const getSnapMenuLineItem = (item: LineItem) => ({
  ...item,
  value: item.id,
  label: (item.sku && item.name && `${item.sku} - ${item.name}`) || item.sku || item.name,
});
